module.exports = __webpack_public_path__ + "static/media/bg_transmissoes.84ef36d6.webp";